import React from "react";
import PageHeader from "../components/page-header";

const SolutionsTravelTechConsulting = () => {
  return (
    <div className="page-inside page-booking-engine">
      <PageHeader page="travel-tech-consulting" />
      <div className="container">
        <div>
          <p>
            TravelCarma helps travel companies solve complex technology problems
            through AI-first, integration-ready travel technology consulting. We
            help AI-enable existing workflows, manage and extend legacy systems,
            integrate and normalize supplier/API data, deploy dedicated travel
            technology engineering teams, and build bespoke travel platforms
            when off-the-shelf software cannot fit.
          </p>
          <p>
            Our consulting is grounded in 20+ years of building real travel
            products and platforms: booking engines, B2B/B2C portals, Travel
            CRM, supplier integrations, itinerary and quotation workflows,
            back-office systems, API aggregation layers, and enterprise travel
            infrastructure. That product-building history gives us practical
            insight into the systems travel companies already depend on.
          </p>
          <p>
            We do not force rip-and-replace. We work with existing travel
            technology stacks, identify where AI and automation can create real
            value, and modernize in controlled phases so live operations can
            keep running.
          </p>
          <p>
            <strong>
              Use TravelCarma when you need a travel technology partner who can
              move from strategy into execution: AI enablement, managed
              services, dedicated engineering teams, supplier/API integration,
              and bespoke platform engineering around your real business model.
            </strong>
          </p>

          <div className="shadow rounded p-4 mt-5">
            <h3 className="text-primary mb-4">
              Our AI-First Travel Technology Consulting Framework:
            </h3>
            <ul>
              <li className="mb-3">
                Assess your current travel technology stack, workflows,
                supplier/API dependencies, and operational constraints
              </li>
              <li className="mb-3">
                Identify practical AI, automation, integration, and
                modernization opportunities
              </li>
              <li className="mb-3">
                Define a phased roadmap that protects working infrastructure
                while improving capability
              </li>
              <li className="mb-3">
                Support execution through dedicated travel technology
                engineering teams and hands-on delivery
              </li>
              <li>
                Continue improving live systems through managed services, custom
                modules, and post-launch optimization
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionsTravelTechConsulting;
